import { useCallback, useState } from 'react';

export const useRefetch = () => {
  const [triggerRefetch, setTriggerRefetch] = useState<boolean>(false);

  const refetch = useCallback(() => {
    setTriggerRefetch((prev) => !prev);
  }, []);

  return {
    triggerRefetch,
    refetch,
  };
};
